import React from 'react';
import { BrowserRouter as Router, Route, Redirect, useHistory } from 'react-router-dom';
import { Security, LoginCallback, SecureRoute, OktaContext } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import Home from './Home';
import StatsRedirect from './StatsRedirect';
import About from './About.js';
import AnalyticsHome from './analytics/AnalyticsHome.js';
import UserException from './admin/user-exception/UserException';
import Admin from './admin';

// const config = {
//     issuer: process.env.REACT_APP_OKTA_ISSUER,
//     redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
//     clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
//     pkce: true,
// };

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    pkce: true,
});

const App = () => {
    const history = useHistory();

    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        console.log("Version: 1.4.15");
        history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    const onAuthRequired = () => {
        oktaAuth.signInWithRedirect();
    };

    return (
        <Security
            oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
            onAuthRequired={onAuthRequired}
        >
            <SecureRoute path="/" exact component={Home} />
            <Route path="/implicit/callback" component={LoginCallback} />
            <SecureRoute path="/about" exact component={About} />
            <SecureRoute path="/admin" component={Admin} />
            <SecureRoute path="/analytics" exact component={AnalyticsHome} />
        </Security>
    );
};

const AppWithRouterAccess = () => (
    <div className="">
        <Router>
            <App />
            <Route path="/redirect/:user/:app" exact component={StatsRedirect} />
        </Router>
    </div>
);

export default AppWithRouterAccess;